import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { FormikErrors, useFormikContext } from "formik";
import React, { useState } from "react";
import { Accordion, Button } from "react-bootstrap";

import { AddressAndResidentialField, PersonalInfoField } from "../../../config/filingConstants";
import { IActiveTabs, IFormITR1 } from "../../../config/interfaces";
import { useAppDispatch } from "../../../redux/Store";
import { UtilService } from "../../../services";
import FASvgIcon from "../../FASvgIcon";
import PreventEditComponent from "../../PreventEditComponent";
import SvgImage from "../../SvgImage";
import ContextAwareToggle from "../../accordion/ContextAwareToggle";
import {
	AddressInfoForm,
	BankDetailsForm,
	PermanentInfoForm
} from "../../itr-filing/personal-details";
import FilingReturnInfoForm from "../../itr-filing/personal-details/forms/FilingReturnInfoForm";

type Props = {
	handleNaviagteTab: (tabName: IActiveTabs) => void;
	allValidationError: FormikErrors<IFormITR1>;
};

const PersonalDetailsTab: React.FC<Props> = (props: Props) => {
	const { handleNaviagteTab, allValidationError } = props;

	const [showLinkPAN, setShowLinkPAN] = useState<boolean>(false);

	const dispatch = useAppDispatch();

	const { values, errors } = useFormikContext<IFormITR1>();

	const personalInfoError = UtilService.GetError(PersonalInfoField, allValidationError, errors);
	const addressResidentialError = UtilService.GetError(
		AddressAndResidentialField,
		allValidationError,
		errors
	);
	const addtnlBankDetailsError = UtilService.GetError(
		["AddtnlBankDetails"],
		allValidationError,
		errors
	);
	const FilingReturnInfoError = UtilService.GetError(
		["FilingReturnInfo"],
		allValidationError,
		errors
	);

	return (
		<>
			<Accordion defaultActiveKey={"personal-details-0"} flush>
				<Accordion.Item
					eventKey="personal-details-0"
					className={classNames(
						"border",
						"border-1",
						personalInfoError ? "border-danger" : "border-transparent"
					)}
				>
					<ContextAwareToggle eventKey="personal-details-0">
						<div className="btn-content">
							<SvgImage
								imgId={personalInfoError ? "remaining-information" : "permanent-information"}
							/>
							<h4 className="mb-0">
								Personal Info
								{personalInfoError ? (
									<small className="fw-bold text-danger">
										Please correct the errors found in Personal Info.
									</small>
								) : null}
							</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<PermanentInfoForm />
					</Accordion.Body>
				</Accordion.Item>

				<Accordion.Item
					eventKey="personal-details-1"
					className={classNames(
						"border",
						"border-1",
						addressResidentialError ? "border-danger" : "border-transparent"
					)}
				>
					<ContextAwareToggle eventKey="personal-details-1">
						<div className="btn-content">
							<SvgImage
								imgId={
									addressResidentialError ? "remaining-information" : "residential-information"
								}
							/>
							<h4 className="mb-0">
								Address and Residential Status
								{addressResidentialError ? (
									<small className="fw-bold text-danger">
										Please correct the errors found in Address and Residential Status.
									</small>
								) : null}
							</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<AddressInfoForm />
					</Accordion.Body>
				</Accordion.Item>

				<Accordion.Item
					eventKey="personal-details-2"
					className={classNames(
						"border",
						"border-1",
						addtnlBankDetailsError ? "border-danger" : "border-transparent"
					)}
				>
					<ContextAwareToggle eventKey="personal-details-2">
						<div className="btn-content">
							<SvgImage
								imgId={addtnlBankDetailsError ? "remaining-information" : "bank-information"}
							/>
							<h4 className="mb-0">
								Bank Details
								{addtnlBankDetailsError ? (
									<small className="fw-bold text-danger">
										Please correct the errors found in Bank Details.
									</small>
								) : null}
							</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<BankDetailsForm />
					</Accordion.Body>
				</Accordion.Item>

				{/* -------------------------------------------------------------------------------- */}
				<Accordion.Item
					eventKey="personal-details-3"
					className={classNames(
						"border",
						"border-1",
						FilingReturnInfoError ? "border-danger" : "border-transparent"
					)}
				>
					<ContextAwareToggle eventKey="personal-details-3">
						<div className="btn-content">
							<SvgImage
								imgId={FilingReturnInfoError ? "remaining-information" : "filing-return-info"}
							/>
							<h4 className="mb-0">
								Filing Return Info
								{FilingReturnInfoError ? (
									<small className="fw-bold text-danger">
										Please correct the errors found in Filing Return Info.
									</small>
								) : null}
							</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<FilingReturnInfoForm />
					</Accordion.Body>
				</Accordion.Item>

				{/* -------------------------------------------------------------------------------------- */}

				{/* <Accordion.Item eventKey="personal-details-3">
          <ContextAwareToggle eventKey="personal-details-3">
            <div className="btn-content">
              <SvgImage imgId="link-pan-information" />
              <h4 className="mb-0">Link your PAN</h4>
            </div>
          </ContextAwareToggle>
          <Accordion.Body>
            <hr />
            <section>
              <div className="section-title-wrap">
                <h5>
                  Your PAN
                  <small>PAN Linking is a mandatory requirement to e-file your returns.</small>
                </h5>
                <PreventEditComponent>
                  <Button variant="primaryDark" size="sm" onClick={() => setShowLinkPAN(true)}>
                    Link your PAN
                  </Button>
                </PreventEditComponent>
              </div>
              <dl className="eds-list eds-dl eds-inline-between">
                <div className="eds-list--item">
                  <dt>EGFDP7534P</dt>
                  <PreventEditComponent>
                    <dd>
                      <Button
                        variant="link"
                        // onClick={() => {
                        //   setShowAddFormCanvas(() => true);
                        //   setActiveItem(() => income);
                        //   setActiveItemIdx(() => String(index));
                        // }}
                      >
                        Unlink
                      </Button>
                    </dd>
                  </PreventEditComponent>
                </div>
              </dl>
            </section>
            <PANLinkFormModal
              showModal={showLinkPAN}
              handleModalClose={() => setShowLinkPAN(false)}
              handleRefresh={() => console.log("refresh")}
            />
          </Accordion.Body>
        </Accordion.Item> */}
			</Accordion>

			<PreventEditComponent>
				<div className="btns-wrap justify-content-end">
					<Button
						size="lg"
						type="button"
						variant="primary"
						onClick={() => handleNaviagteTab("income-details")}
					>
						Proceed <FASvgIcon icon={faArrowRight} />
					</Button>
				</div>
			</PreventEditComponent>
		</>
	);
};

export default PersonalDetailsTab;
